// These discounts are promo codes that are automatically applied to certain pass types
// If no discounts currently exist, just export an empty array

import { PURCHASE_TYPES } from "./constants";

export const laxDiscounts = [
  {
    subscriptionTypeId: 2310130, // 30-Day pass
    displayPrice: "30 days of access for <s>$17</s> <b>$1</b>",
    promo: "BIKEGREEN25", // Promo code to automatically apply
    discountText: "<strong>Special price with code BIKEGREEN25</strong>",
    shouldApply: () => {
      // This discount is only valid for September 2025
      const today = new Date();
      return today.getFullYear() === 2025 && today.getMonth() === 8; // September 2025 (month is 0-indexed)
    },
    purchaseTypes: [PURCHASE_TYPES.change, PURCHASE_TYPES.new], // Only for users changing pass type
  },
  {
    subscriptionTypeId: 2310131, // 30-Day Reduced Fare pass
    displayPrice: "30 days of access for <s>$5</s> <b>$1</b>",
    promo: "BIKEGREEN25", // Promo code to automatically apply
    discountText: "<strong>Special price with code BIKEGREEN25</strong>",
    shouldApply: () => {
      // This discount is only valid for September 2025
      const today = new Date();
      return today.getFullYear() === 2025 && today.getMonth() === 8; // September 2025 (month is 0-indexed)
    },
    purchaseTypes: [PURCHASE_TYPES.change, PURCHASE_TYPES.new], // Only for users changing pass type
  },
];
